import styled from 'styled-components'
import { MAIN_BACKGROUND } from 'constants/colors'

export const StyledLookupTaskSectionWrapper = styled.div`
  padding: 15px;
  background-color: ${MAIN_BACKGROUND};
`
